import { render, staticRenderFns } from "./TiposProjeto.vue?vue&type=template&id=116ce4ba&"
import script from "./TiposProjeto.vue?vue&type=script&lang=js&"
export * from "./TiposProjeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports